import { KpkAutoComplete } from "@keepeek/commons";
import { atomFamily } from "recoil";

export const queryState = atomFamily<string, string>({
  key: "QueryState",
  default: "",
});

export const autoCompleteQueryState = atomFamily<string, string>({
  key: "AutoCompleteQueryState",
  default: "",
});

export const autoCompleteState = atomFamily<KpkAutoComplete[] | null, string>({
  key: "AutoCompleteState",
  default: [],
});
